module.exports = __webpack_public_path__ + "img/user-login.040e397d.svg";